/*
 * Module for a generic area to view and modify a list of "something".  This can be conversation variables,
 * mart statuses, or privileged area roles.  The module includes a selectable list and another submodule to
 * edit the selected item.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/basicAdminList/basicAdminListView",
  "modules/shared/sortableList/sortableListModule",
  "modules/shared/basicAdminItemModal/basicAdminItemModalModule",
  "modules/shared/basicAdminList/basicAdminListModel",
], function (
  Marionette,
  Messenger,
  BasicAdminListView,
  SortableListModule,
  BasicAdminItemModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "basicAdminList";
      this.region = options.region;

      this.areaModel = options.areaModel;
      this._setUpVents();
    },
    show: function () {
      //set a no-op save handler (saves are handled automatically in the modal)
      Messenger.onSave(function () {
        console.log("basicAdmin save");
        Messenger.saveAttempted(true); //success
      }, this);

      const listCollection = Messenger.reqres.request(this.areaModel.get("reqres"));
      this.layout = new BasicAdminListView.basicAdminListLayout({ model: this.areaModel });
      //pass the area model, so we can assign the correct attribute names
      const headers = Messenger.reqres.request("admin:list:headers", this.areaModel);
      //add an event for deleting items from the sortable list when the delete button is pressed
      const _areaModel = this.areaModel; //need local variable that's not part of 'this' for the event callback, since
      // 'this' becomes the itemView
      const extendedEvents = {
        "click #deleteItem": function () {
          Messenger.yesNoDialog(
            _areaModel.get("deleteMessage"),
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete " + _areaModel.get("trackType"),
                  id: this.model.id,
                  idType: _areaModel.get("trackType"),
                  object: _areaModel.get("trackType"),
                });
                this.model.deleteModel();
              },
            },
            this,
          );
        },
      };
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.areaModel.get("namespace"),
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          extendedEvents: extendedEvents,
        }),
      );

      //add a new item to the list
      this.layout.on(
        "add:item",
        function () {
          const newItem = listCollection.addItem();
          //show the item modal
          Messenger.vent.trigger(
            "show:modal",
            BasicAdminItemModalModule,
            {},
            {
              itemModel: newItem,
              areaModel: this.areaModel,
            },
            {
              title: this.areaModel.get("addModalTitle"),
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: 400,
              trackInteraction: {
                action: "Add " + this.areaModel.get("trackType"),
                object: this.areaModel.get("trackType"),
              },
            },
          );
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(listCollection);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function (listCollection) {
      this.list.show(listCollection);
    },
    _setUpVents: function () {
      //item from the list is selected, so show the item module
      Messenger.vent.on(
        this.areaModel.get("namespace") + ":selected:row",
        function (item) {
          //show item modal
          Messenger.vent.trigger(
            "show:modal",
            BasicAdminItemModalModule,
            {},
            {
              itemModel: item,
              areaModel: this.areaModel,
            },
            {
              title: this.areaModel.get("editModalTitle"),
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: 400,
              trackInteraction: {
                action: "Edit " + this.areaModel.get("trackType"),
                id: item.id,
                idType: this.areaModel.get("trackType"),
                object: this.areaModel.get("trackType"),
              },
            },
          );
        },
        this,
      );

      //show the module
      Messenger.vent.on(
        "show:" + this.areaModel.get("namespace"),
        function () {
          this.show();
        },
        this,
      );
    },
  });
});
